(function () {
    'use strict';

    var module = angular.module('uwAgenda.help');
    module.factory('HelpService', ['$http', HelpServiceFn]);

    /* service for requesting helps */
    function HelpServiceFn($http) {

        var baseUrl = '/api/help/';
        var service = {
            query: query,
            get: get,
            save: save,
            update: update,
            remove: remove,
            search: search
        };

        return service;

        /* list all helps - optional categoryId */
        function query(categoryId) {
            return $http.get(baseUrl + (categoryId !== "" ? 'category/' + categoryId : "")).then(function (response) { return response.data; });
        }

        /* search */
        function search(searchValue) {
            return $http.get(baseUrl + 'search/' + searchValue).then(function (response) { return response.data; });
        }

        /* get help item */
        function get(id) {
            return $http.get(baseUrl + id).then(function (response) { return response.data; });
        }

        /* posts help */
        function save(help) {
            return $http.post(baseUrl, help).then(function (response) { return response.data; });
        }

        /* deactivate help */
        function remove(id) {
            return $http.delete(baseUrl + id).then(function (response) { return response.data; });
        }

        function update(id, help) {
            return $http.put(baseUrl + id, help).then(function (response) { return response.data; });
        }
    }
})();